'use client'

import { useEffect, useState } from 'react'

import { ChevronIcon } from '@/components/icons/chevron-icon'
import { usePaymentStore } from '@/hooks/use-payment-controller/store'
import {
  isDetailOpenSelector,
  setDetailOpenSelector,
} from '@/hooks/use-payment-controller/selectors'

export default function NavbarCart() {
  const setDetailOpen = usePaymentStore(setDetailOpenSelector)
  const isDetailOpen = usePaymentStore(isDetailOpenSelector)
  const [isOpen, setOpen] = useState<boolean>(false)

  const closeNavBar = () => {
    setDetailOpen(false)
  }
  const openNavBar = () => {
    setDetailOpen(true)
  }

  useEffect(() => {
    setOpen(isDetailOpen)
  }, [isDetailOpen])

  useEffect(() => {
    setOpen(false)
  }, [])

  return (
    <div className="text-checkout-s text-medium flex items-center md:hidden">
      {isOpen && (
        <button
          className="flex flex-row items-center gap-2 text-white"
          onClick={closeNavBar}>
          Cerrar <ChevronIcon css={{ rotate: '180deg' }} />
        </button>
      )}

      {!isOpen && (
        <button
          className="flex flex-row items-center gap-2 text-white"
          onClick={openNavBar}>
          Carrito <ChevronIcon />
        </button>
      )}
    </div>
  )
}
